import { promptAuthLogin } from '@/utils/auth-session';

/** 打开交易弹窗前鉴权：未登录则弹登录框并返回 false */
export function requireAuthForTrade() {
  return promptAuthLogin();
}
